<template>
  <router-view />
</template>

<script lang="ts">
import Vue from 'vue'
import { mapMutations, mapActions } from 'vuex'
export default Vue.extend({
  name: 'App',
  data: () => ({
    //
  }),
  methods: {
    ...mapMutations('usuario', ['authData']),
    ...mapActions('usuario', ['getPerfil'])
  },
  async created () {
    try {
      this.authData()
      if (localStorage.getItem('token')) await this.getPerfil()
    } catch (error) {
      localStorage.clear()
      console.log(error, 'otros App')
    }
  }
})
</script>
<style lang="scss">
</style>
